/*
  Peachito Accessibility Widget Script
  Store: peachito.co.il
  Compliance: Israeli Standard IS 5568 / WCAG 2.1 Level AA
*/

(function () {
  // Localization dictionaries
  const i18n = {
    he: {
      langLabel: "English",
      title: "תפריט נגישות",
      close: "סגור תפריט",
      reset: "איפוס הגדרות",
      profileSection: "פרופילי נגישות מהירים",
      adjustSection: "התאמות אישיות",
      statement: "הצהרת נגישות",
      report: "דיווח על תקלה",
      brand: "נגישות Peachito",
      
      // Profiles
      profileScreenReaderTitle: "קורא מסך",
      profileScreenReaderDesc: "התאמה לעיוורים ומסייע קורא מסך",
      profileVisualTitle: "לקויי ראייה",
      profileVisualDesc: "טקסט מוגדל וניגודיות גבוהה",
      profileCognitiveTitle: "קוגניטיבי",
      profileCognitiveDesc: "מיקוד כותרות וניווט קל במיוחד",
      profileAdhdTitle: "קשב וריכוז",
      profileAdhdDesc: "עצירת תנועה ומסכת מיקוד לקריאה",
      profileKeyboardTitle: "ניווט מקלדת",
      profileKeyboardDesc: "הדגשת פוקוס וניווט מלא ללא עכבר",

      // Controls
      contrastLabel: "ניגודיות וצבעים",
      contrastDark: "ניגודיות הפוכה",
      contrastLight: "רקע בהיר",
      contrastMono: "מונוכרום (אפור)",
      
      textSizeLabel: "הגדלת טקסט",
      readableFontLabel: "גופן קריא (Arial)",
      highlightLinksLabel: "הדגשת קישורים",
      highlightTitlesLabel: "הדגשת כותרות",
      stopAnimationsLabel: "עצירת אנימציות",
      
      cursorLabel: "סמן עכבר גדול",
      cursorBlack: "סמן שחור",
      cursorWhite: "סמן לבן",
      
      rulerLabel: "סרגל קריאה",
      maskLabel: "מסכת קריאה",
      keyboardFocusLabel: "הדגשת פוקוס מקלדת",
      
      lineHeightLabel: "מרווח שורות",
      spacingLabel: "מרווח אותיות ומילים",

      // Announcement Messages
      statusReset: "הגדרות הנגישות אופסו לחלוטין",
      statusEnabled: "הופעל",
      statusDisabled: "בוטל",
      statusContrastDark: "ניגודיות הפוכה הופעלה",
      statusContrastLight: "ניגודיות רקע בהיר הופעלה",
      statusContrastMono: "מצב מונוכרום הופעל",
      statusContrastDefault: "חזרנו לצבעי האתר המקוריים",
      statusTextSize: "גודל הטקסט שונה לרמה",
      statusFontReadable: "מצב גופן קריא",
      statusLinksHighlight: "הדגשת קישורים",
      statusTitlesHighlight: "הדגשת כותרות",
      statusAnimationsStop: "עצירת אנימציות",
      statusCursor: "סמן עכבר שונה ל",
      statusRuler: "סרגל קריאה",
      statusMask: "מסכת קריאה",
      statusKeyboardFocus: "הדגשת פוקוס מקלדת",
      statusLineHeight: "מרווח שורות שונה לרמה",
      statusSpacing: "מרווח שורות ואותיות שונה לרמה"
    },
    en: {
      langLabel: "עברית",
      title: "Accessibility Menu",
      close: "Close Menu",
      reset: "Reset Settings",
      profileSection: "Quick Profiles",
      adjustSection: "Custom Adjustments",
      statement: "Accessibility Statement",
      report: "Report an Issue",
      brand: "Peachito Accessibility",
      
      // Profiles
      profileScreenReaderTitle: "Screen Reader",
      profileScreenReaderDesc: "Optimized for blind & screen reader users",
      profileVisualTitle: "Visually Impaired",
      profileVisualDesc: "Scaled text & enhanced contrast",
      profileCognitiveTitle: "Cognitive Support",
      profileCognitiveDesc: "Emphasized headings & simple nav",
      profileAdhdTitle: "ADHD Friendly",
      profileAdhdDesc: "Stops movement & focuses reading path",
      profileKeyboardTitle: "Keyboard Nav",
      profileKeyboardDesc: "Strong focus styling & key navigation",

      // Controls
      contrastLabel: "Contrast & Colors",
      contrastDark: "Dark Contrast",
      contrastLight: "Light Contrast",
      contrastMono: "Monochrome",
      
      textSizeLabel: "Increase Text",
      readableFontLabel: "Readable Font (Arial)",
      highlightLinksLabel: "Highlight Links",
      highlightTitlesLabel: "Highlight Headings",
      stopAnimationsLabel: "Stop Animations",
      
      cursorLabel: "Large Cursor",
      cursorBlack: "Large Black",
      cursorWhite: "Large White",
      
      rulerLabel: "Reading Ruler",
      maskLabel: "Reading Mask",
      keyboardFocusLabel: "Keyboard Focus Ring",
      
      lineHeightLabel: "Line Height",
      spacingLabel: "Letter & Word Spacing",

      // Announcement Messages
      statusReset: "Accessibility settings have been fully reset",
      statusEnabled: "enabled",
      statusDisabled: "disabled",
      statusContrastDark: "Reverse contrast enabled",
      statusContrastLight: "Light contrast enabled",
      statusContrastMono: "Monochrome mode enabled",
      statusContrastDefault: "Contrast reset to default website styles",
      statusTextSize: "Text size changed to level",
      statusFontReadable: "Readable font mode",
      statusLinksHighlight: "Link highlighting",
      statusTitlesHighlight: "Heading highlighting",
      statusAnimationsStop: "Animation stopping",
      statusCursor: "Mouse cursor changed to",
      statusRuler: "Reading ruler",
      statusMask: "Reading mask",
      statusKeyboardFocus: "Keyboard focus highlight",
      statusLineHeight: "Line height changed to level",
      statusSpacing: "Spacing changed to level"
    }
  };

  // State Management
  const defaultSettings = {
    lang: "he",
    activeProfile: null, // "screenReader", "visual", "cognitive", "adhd", "keyboard"
    contrast: "default", // "default", "dark", "light", "mono"
    textSize: 0, // 0 to 4
    readableFont: false,
    highlightLinks: false,
    highlightTitles: false,
    stopAnimations: false,
    cursor: "default", // "default", "black", "white"
    ruler: false,
    mask: false,
    keyboardFocus: false,
    lineHeight: 0, // 0 to 3
    spacing: 0 // 0 to 3
  };

  let settings = { ...defaultSettings };

  // DOM Elements cache
  let fab, modal, closeBtn, langToggle, resetBtn, announcer;
  let rulerElement, maskTop, maskBottom;
  let lastActiveElementBeforeModalOpen = null;

  // Load settings from LocalStorage
  function loadSettings() {
    try {
      const stored = localStorage.getItem("peachito_acc_settings");
      if (stored) {
        settings = { ...defaultSettings, ...JSON.parse(stored) };
      }
    } catch (e) {
      console.warn("Could not load accessibility settings from localStorage", e);
    }
  }

  // Save settings to LocalStorage
  function saveSettings() {
    try {
      localStorage.setItem("peachito_acc_settings", JSON.stringify(settings));
    } catch (e) {
      console.warn("Could not save accessibility settings to localStorage", e);
    }
  }

  // Screen Reader Live Announcements
  function announce(message) {
    if (!announcer) return;
    announcer.textContent = "";
    setTimeout(() => {
      announcer.textContent = message;
    }, 50);
  }

  // Initialize DOM helpers
  function initDOMHelpers() {
    // 1. Reading Ruler
    if (!document.getElementById("peach-acc-ruler")) {
      rulerElement = document.createElement("div");
      rulerElement.id = "peach-acc-ruler";
      document.body.appendChild(rulerElement);
    } else {
      rulerElement = document.getElementById("peach-acc-ruler");
    }

    // 2. Reading Mask
    if (!document.getElementById("peach-acc-mask-top")) {
      maskTop = document.createElement("div");
      maskTop.id = "peach-acc-mask-top";
      maskTop.className = "peach-acc-mask-overlay";
      document.body.appendChild(maskTop);
    } else {
      maskTop = document.getElementById("peach-acc-mask-top");
    }

    if (!document.getElementById("peach-acc-mask-bottom")) {
      maskBottom = document.createElement("div");
      maskBottom.id = "peach-acc-mask-bottom";
      maskBottom.className = "peach-acc-mask-overlay";
      document.body.appendChild(maskBottom);
    } else {
      maskBottom = document.getElementById("peach-acc-mask-bottom");
    }

    // 3. Screen Reader Announcer
    if (!document.getElementById("peach-acc-announcer")) {
      announcer = document.createElement("div");
      announcer.id = "peach-acc-announcer";
      announcer.className = "peach-acc-widget-reset";
      announcer.style.cssText = "position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;";
      announcer.setAttribute("aria-live", "polite");
      announcer.setAttribute("aria-atomic", "true");
      document.body.appendChild(announcer);
    } else {
      announcer = document.getElementById("peach-acc-announcer");
    }

    // Tracking mouse movements for ruler and mask (rAF throttled & GPU accelerated)
    let mouseY = 0;
    let viewportHeight = window.innerHeight;
    let ticking = false;

    window.addEventListener("resize", function () {
      viewportHeight = window.innerHeight;
    }, { passive: true });

    document.addEventListener("mousemove", function (e) {
      if (!settings.ruler && !settings.mask) return;
      mouseY = e.clientY;
      if (!ticking) {
        requestAnimationFrame(updateOverlays);
        ticking = true;
      }
    }, { passive: true });

    function updateOverlays() {
      if (settings.ruler && rulerElement) {
        rulerElement.style.transform = `translate3d(0, ${mouseY}px, 0) translateY(-50%)`;
      }
      if (settings.mask && maskTop && maskBottom) {
        const gap = 50; // 100px focus area gap
        maskTop.style.height = Math.max(0, mouseY - gap) + "px";
        maskBottom.style.transform = `translate3d(0, ${mouseY + gap}px, 0)`;
      }
      ticking = false;
    }
  }

  // Apply visual overrides to root element (html)
  function applyAccessibilityOverrides() {
    const htmlElement = document.documentElement;
    const txt = i18n[settings.lang];

    // Contrast
    htmlElement.classList.remove("peach-acc-contrast-dark", "peach-acc-contrast-light", "peach-acc-contrast-mono");
    if (settings.contrast === "dark") htmlElement.classList.add("peach-acc-contrast-dark");
    else if (settings.contrast === "light") htmlElement.classList.add("peach-acc-contrast-light");
    else if (settings.contrast === "mono") htmlElement.classList.add("peach-acc-contrast-mono");

    // Text Size
    if (settings.textSize > 0) {
      htmlElement.setAttribute("data-peach-acc-text-size", settings.textSize);
    } else {
      htmlElement.removeAttribute("data-peach-acc-text-size");
    }

    // Line Height
    htmlElement.classList.remove("peach-acc-line-height-1", "peach-acc-line-height-2", "peach-acc-line-height-3");
    if (settings.lineHeight > 0) {
      htmlElement.classList.add(`peach-acc-line-height-${settings.lineHeight}`);
    }

    // Letter & Word Spacing
    htmlElement.classList.remove("peach-acc-spacing-1", "peach-acc-spacing-2", "peach-acc-spacing-3");
    if (settings.spacing > 0) {
      htmlElement.classList.add(`peach-acc-spacing-${settings.spacing}`);
    }

    // Readable Font
    htmlElement.classList.toggle("peach-acc-readable-font", settings.readableFont);

    // Highlight Links
    htmlElement.classList.toggle("peach-acc-highlight-links", settings.highlightLinks);

    // Highlight Titles
    htmlElement.classList.toggle("peach-acc-highlight-titles", settings.highlightTitles);

    // Stop Animations
    htmlElement.classList.toggle("peach-acc-stop-animations", settings.stopAnimations);

    // Cursors
    htmlElement.classList.remove("peach-acc-cursor-black", "peach-acc-cursor-white");
    if (settings.cursor === "black") htmlElement.classList.add("peach-acc-cursor-black");
    else if (settings.cursor === "white") htmlElement.classList.add("peach-acc-cursor-white");

    // Ruler
    htmlElement.classList.toggle("peach-acc-ruler-active", settings.ruler);

    // Mask
    htmlElement.classList.toggle("peach-acc-mask-active", settings.mask);
    if (settings.mask && maskTop && maskBottom) {
      // Default initial layout for mask before mouse starts moving
      maskTop.style.height = "30vh";
      maskBottom.style.transform = "translate3d(0, calc(30vh + 100px), 0)";
      maskBottom.style.height = "100vh";
    }

    // Keyboard Focus Indicator Mode
    htmlElement.classList.toggle("peach-acc-keyboard-focus", settings.keyboardFocus);
  }

  // Update text inside the modal dynamically based on active language
  function updateLocalizationUI() {
    const text = i18n[settings.lang];
    
    // Set text dir on modal
    if (modal) {
      modal.setAttribute("dir", settings.lang === "he" ? "rtl" : "ltr");
    }

    // Header Title
    const titleText = document.getElementById("peach-acc-title-text");
    if (titleText) titleText.textContent = text.title;

    // Language selector button
    if (langToggle) langToggle.textContent = text.langLabel;

    // Reset settings button
    const resetText = document.getElementById("peach-acc-reset-text");
    if (resetText) resetText.textContent = text.reset;

    // Section headers
    const secProfiles = document.getElementById("peach-acc-sec-profiles");
    if (secProfiles) secProfiles.textContent = text.profileSection;

    const secAdjust = document.getElementById("peach-acc-sec-adjustments");
    if (secAdjust) secAdjust.textContent = text.adjustSection;

    // Footer Statement and Report links
    const statementLink = document.getElementById("peach-acc-link-statement");
    if (statementLink) statementLink.textContent = text.statement;

    const feedbackLink = document.getElementById("peach-acc-link-feedback");
    if (feedbackLink) {
      feedbackLink.textContent = text.report;
      feedbackLink.setAttribute("href", "mailto:peachito.baby@gmail.com?subject=Accessibility%20Feedback");
    }

    // Close button aria-label
    if (closeBtn) closeBtn.setAttribute("aria-label", text.close);

    // Dynamic translation for profiles
    updateProfileTranslation("screenReader", text.profileScreenReaderTitle, text.profileScreenReaderDesc);
    updateProfileTranslation("visual", text.profileVisualTitle, text.profileVisualDesc);
    updateProfileTranslation("cognitive", text.profileCognitiveTitle, text.profileCognitiveDesc);
    updateProfileTranslation("adhd", text.profileAdhdTitle, text.profileAdhdDesc);
    updateProfileTranslation("keyboard", text.profileKeyboardTitle, text.profileKeyboardDesc);

    // Dynamic translation for adjustment cards
    updateControlTranslation("contrast-dark", text.contrastDark);
    updateControlTranslation("contrast-light", text.contrastLight);
    updateControlTranslation("contrast-mono", text.contrastMono);
    updateControlTranslation("readable-font", text.readableFontLabel);
    updateControlTranslation("highlight-links", text.highlightLinksLabel);
    updateControlTranslation("highlight-titles", text.highlightTitlesLabel);
    updateControlTranslation("stop-animations", text.stopAnimationsLabel);
    updateControlTranslation("ruler", text.rulerLabel);
    updateControlTranslation("mask", text.maskLabel);
    updateControlTranslation("keyboard-focus", text.keyboardFocusLabel);

    // Group labels
    const contrastGroupLabel = document.getElementById("peach-acc-group-contrast");
    if (contrastGroupLabel) contrastGroupLabel.textContent = text.contrastLabel;

    const textSizeGroupLabel = document.getElementById("peach-acc-group-textsize");
    if (textSizeGroupLabel) textSizeGroupLabel.textContent = text.textSizeLabel;

    const cursorGroupLabel = document.getElementById("peach-acc-group-cursor");
    if (cursorGroupLabel) cursorGroupLabel.textContent = text.cursorLabel;

    const lineHeightGroupLabel = document.getElementById("peach-acc-group-lineheight");
    if (lineHeightGroupLabel) lineHeightGroupLabel.textContent = text.lineHeightLabel;

    const spacingGroupLabel = document.getElementById("peach-acc-group-spacing");
    if (spacingGroupLabel) spacingGroupLabel.textContent = text.spacingLabel;

    // Cursors select options
    const cursorNoneBtn = document.getElementById("peach-acc-cursor-none-btn");
    const cursorBlackBtn = document.getElementById("peach-acc-cursor-black-btn");
    const cursorWhiteBtn = document.getElementById("peach-acc-cursor-white-btn");
    if (cursorNoneBtn) cursorNoneBtn.textContent = settings.lang === "he" ? "רגיל" : "Default";
    if (cursorBlackBtn) cursorBlackBtn.textContent = text.cursorBlack;
    if (cursorWhiteBtn) cursorWhiteBtn.textContent = text.cursorWhite;

    // Reset status of widgets
    syncWidgetControls();
  }

  function updateProfileTranslation(key, title, desc) {
    const card = document.querySelector(`.peach-acc-profile-card[data-profile="${key}"]`);
    if (card) {
      const h3 = card.querySelector("h3");
      const p = card.querySelector("p");
      if (h3) h3.textContent = title;
      if (p) p.textContent = desc;
      card.setAttribute("aria-label", `${title}: ${desc}`);
    }
  }

  function updateControlTranslation(key, label) {
    const card = document.querySelector(`.peach-acc-control-card[data-control="${key}"]`);
    if (card) {
      const span = card.querySelector(".peach-acc-control-label");
      if (span) span.textContent = label;
      card.setAttribute("aria-label", label);
    }
  }

  // Synchronize Widget Buttons active classes with state
  function syncWidgetControls() {
    // Profiles
    document.querySelectorAll(".peach-acc-profile-card").forEach(card => {
      const pKey = card.getAttribute("data-profile");
      if (settings.activeProfile === pKey) {
        card.classList.add("is-active");
        card.setAttribute("aria-checked", "true");
      } else {
        card.classList.remove("is-active");
        card.setAttribute("aria-checked", "false");
      }
    });

    // Individual Toggles
    const toggles = [
      { key: "readableFont", select: '[data-control="readable-font"]' },
      { key: "highlightLinks", select: '[data-control="highlight-links"]' },
      { key: "highlightTitles", select: '[data-control="highlight-titles"]' },
      { key: "stopAnimations", select: '[data-control="stop-animations"]' },
      { key: "ruler", select: '[data-control="ruler"]' },
      { key: "mask", select: '[data-control="mask"]' },
      { key: "keyboardFocus", select: '[data-control="keyboard-focus"]' }
    ];

    toggles.forEach(t => {
      const card = document.querySelector(t.select);
      if (card) {
        if (settings[t.key]) {
          card.classList.add("is-active");
          card.setAttribute("aria-checked", "true");
        } else {
          card.classList.remove("is-active");
          card.setAttribute("aria-checked", "false");
        }
      }
    });

    // Contrasts
    const contrastDark = document.querySelector('[data-control="contrast-dark"]');
    const contrastLight = document.querySelector('[data-control="contrast-light"]');
    const contrastMono = document.querySelector('[data-control="contrast-mono"]');

    if (contrastDark) {
      contrastDark.classList.toggle("is-active", settings.contrast === "dark");
      contrastDark.setAttribute("aria-checked", settings.contrast === "dark" ? "true" : "false");
    }
    if (contrastLight) {
      contrastLight.classList.toggle("is-active", settings.contrast === "light");
      contrastLight.setAttribute("aria-checked", settings.contrast === "light" ? "true" : "false");
    }
    if (contrastMono) {
      contrastMono.classList.toggle("is-active", settings.contrast === "mono");
      contrastMono.setAttribute("aria-checked", settings.contrast === "mono" ? "true" : "false");
    }

    // Text Size Button Group
    document.querySelectorAll("#peach-acc-textsize-group button").forEach(btn => {
      const val = parseInt(btn.getAttribute("data-val"));
      if (settings.textSize === val) {
        btn.classList.add("active-val");
        btn.setAttribute("aria-pressed", "true");
      } else {
        btn.classList.remove("active-val");
        btn.setAttribute("aria-pressed", "false");
      }
    });

    // Cursors Button Group
    document.querySelectorAll("#peach-acc-cursor-group button").forEach(btn => {
      const val = btn.getAttribute("data-val");
      if (settings.cursor === val) {
        btn.classList.add("active-val");
        btn.setAttribute("aria-pressed", "true");
      } else {
        btn.classList.remove("active-val");
        btn.setAttribute("aria-pressed", "false");
      }
    });

    // Line Height Button Group
    document.querySelectorAll("#peach-acc-lineheight-group button").forEach(btn => {
      const val = parseInt(btn.getAttribute("data-val"));
      if (settings.lineHeight === val) {
        btn.classList.add("active-val");
        btn.setAttribute("aria-pressed", "true");
      } else {
        btn.classList.remove("active-val");
        btn.setAttribute("aria-pressed", "false");
      }
    });

    // Spacing Button Group
    document.querySelectorAll("#peach-acc-spacing-group button").forEach(btn => {
      const val = parseInt(btn.getAttribute("data-val"));
      if (settings.spacing === val) {
        btn.classList.add("active-val");
        btn.setAttribute("aria-pressed", "true");
      } else {
        btn.classList.remove("active-val");
        btn.setAttribute("aria-pressed", "false");
      }
    });
  }

  // --- Accessibility Toggle Functions ---

  function resetAll() {
    const prevLang = settings.lang;
    settings = { ...defaultSettings, lang: prevLang };
    
    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();
    
    const text = i18n[settings.lang];
    announce(text.statusReset);
  }

  function toggleLanguage() {
    settings.lang = settings.lang === "he" ? "en" : "he";
    updateLocalizationUI();
    saveSettings();
    announce(settings.lang === "he" ? "שפת התפריט שונתה לעברית" : "Menu language changed to English");
  }

  function toggleProfile(pKey) {
    const text = i18n[settings.lang];
    
    if (settings.activeProfile === pKey) {
      // Toggle off -> reset settings to default
      resetAll();
      return;
    }

    // Reset first
    settings = { ...defaultSettings, lang: settings.lang, activeProfile: pKey };

    // Apply Profile Presets
    switch (pKey) {
      case "screenReader":
        settings.highlightLinks = true;
        settings.readableFont = true;
        settings.stopAnimations = true;
        settings.keyboardFocus = true;
        announce(text.profileScreenReaderTitle + " - " + text.statusEnabled);
        break;
      case "visual":
        settings.textSize = 2; // Medium Large
        settings.contrast = "dark";
        settings.cursor = "white";
        settings.highlightLinks = true;
        announce(text.profileVisualTitle + " - " + text.statusEnabled);
        break;
      case "cognitive":
        settings.highlightTitles = true;
        settings.highlightLinks = true;
        settings.stopAnimations = true;
        settings.ruler = true;
        announce(text.profileCognitiveTitle + " - " + text.statusEnabled);
        break;
      case "adhd":
        settings.stopAnimations = true;
        settings.mask = true;
        settings.readableFont = true;
        settings.spacing = 1;
        announce(text.profileAdhdTitle + " - " + text.statusEnabled);
        break;
      case "keyboard":
        settings.keyboardFocus = true;
        settings.highlightLinks = true;
        settings.stopAnimations = true;
        announce(text.profileKeyboardTitle + " - " + text.statusEnabled);
        break;
    }

    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();
  }

  function toggleSetting(key, valueMsgPrefix) {
    settings[key] = !settings[key];
    settings.activeProfile = null; // Any individual adjust cancels the active preset profile badge
    
    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();

    const text = i18n[settings.lang];
    const stateMsg = settings[key] ? text.statusEnabled : text.statusDisabled;
    announce(`${valueMsgPrefix} ${stateMsg}`);
  }

  function setContrast(mode) {
    const text = i18n[settings.lang];
    settings.activeProfile = null;

    if (settings.contrast === mode) {
      settings.contrast = "default";
      announce(text.statusContrastDefault);
    } else {
      settings.contrast = mode;
      if (mode === "dark") announce(text.statusContrastDark);
      else if (mode === "light") announce(text.statusContrastLight);
      else if (mode === "mono") announce(text.statusContrastMono);
    }

    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();
  }

  function setTextSize(level) {
    settings.activeProfile = null;
    settings.textSize = level;
    
    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();

    const text = i18n[settings.lang];
    announce(`${text.statusTextSize} ${level}`);
  }

  function setCursor(cursorStyle) {
    settings.activeProfile = null;
    settings.cursor = cursorStyle;
    
    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();

    const text = i18n[settings.lang];
    const cursorNames = {
      default: settings.lang === "he" ? "רגיל" : "Default",
      black: text.cursorBlack,
      white: text.cursorWhite
    };
    announce(`${text.statusCursor} ${cursorNames[cursorStyle]}`);
  }

  function setLineHeight(level) {
    settings.activeProfile = null;
    settings.lineHeight = level;
    
    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();

    const text = i18n[settings.lang];
    announce(`${text.statusLineHeight} ${level}`);
  }

  function setSpacing(level) {
    settings.activeProfile = null;
    settings.spacing = level;
    
    applyAccessibilityOverrides();
    syncWidgetControls();
    saveSettings();

    const text = i18n[settings.lang];
    announce(`${text.statusSpacing} ${level}`);
  }

  // --- Modal Dialog Behavior (Keyboard Trap, Show, Hide) ---

  function ensureModal() {
    if (modal) return true;
    const template = document.getElementById("peach-acc-modal-template");
    if (!template) {
      modal = document.getElementById("peach-acc-modal-dialog");
      if (!modal) return false;
    } else {
      const clone = template.content.cloneNode(true);
      const container = document.querySelector(".peach-acc-widget-reset") || document.body;
      container.appendChild(clone);
      modal = document.getElementById("peach-acc-modal-dialog");
    }
    closeBtn = document.getElementById("peach-acc-close-trigger");
    langToggle = document.getElementById("peach-acc-lang-trigger");
    resetBtn = document.getElementById("peach-acc-reset-trigger");
    bindModalEvents();
    updateLocalizationUI();
    return true;
  }

  function openModal() {
    ensureModal();
    if (!modal) return;
    lastActiveElementBeforeModalOpen = document.activeElement;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    if (fab) fab.setAttribute("aria-expanded", "true");

    // Focus the first interactive element inside the modal (close button or skip link)
    setTimeout(() => {
      if (closeBtn) closeBtn.focus();
    }, 100);

    // Disable tab navigation outside of the modal
    document.addEventListener("keydown", trapFocus);
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    if (fab) fab.setAttribute("aria-expanded", "false");
    
    document.removeEventListener("keydown", trapFocus);

    // Return focus to the FAB button
    if (lastActiveElementBeforeModalOpen) {
      lastActiveElementBeforeModalOpen.focus();
    } else if (fab) {
      fab.focus();
    }
  }

  function trapFocus(e) {
    if (e.key !== "Tab") {
      if (e.key === "Escape") {
        closeModal();
      }
      return;
    }

    if (!modal) return;
    // Query all focusable elements inside the modal
    const focusables = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex="0"]');
    if (!focusables.length) return;
    const firstFocusable = focusables[0];
    const lastFocusable = focusables[focusables.length - 1];

    if (e.shiftKey) {
      // Shift + Tab: Wrap from first to last
      if (document.activeElement === firstFocusable) {
        lastFocusable.focus();
        e.preventDefault();
      }
    } else {
      // Tab: Wrap from last to first
      if (document.activeElement === lastFocusable) {
        firstFocusable.focus();
        e.preventDefault();
      }
    }
  }

  // --- Event Listeners Bindings ---

  function bindModalEvents() {
    if (!modal) return;

    // Close Button Click
    if (closeBtn) closeBtn.addEventListener("click", closeModal);

    // Language Selector Click
    if (langToggle) langToggle.addEventListener("click", toggleLanguage);

    // Reset Button Click
    if (resetBtn) resetBtn.addEventListener("click", resetAll);

    // Close when clicking outside modal bounds
    document.addEventListener("click", function (e) {
      if (modal && modal.classList.contains("is-open") && !modal.contains(e.target) && (!fab || !fab.contains(e.target))) {
        closeModal();
      }
    });

    // Delegated click and keydown handler for modal interactive elements
    modal.addEventListener("click", function (e) {
      const profileCard = e.target.closest(".peach-acc-profile-card");
      if (profileCard) {
        const pKey = profileCard.getAttribute("data-profile");
        toggleProfile(pKey);
        return;
      }

      const controlCard = e.target.closest(".peach-acc-control-card[data-control]");
      if (controlCard) {
        const cKey = controlCard.getAttribute("data-control");
        handleControlAction(cKey);
        return;
      }
    });

    modal.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") {
        const card = e.target.closest(".peach-acc-profile-card, .peach-acc-control-card[data-control]");
        if (card) {
          e.preventDefault();
          card.click();
        }
      }
    });

    // Handler for various card triggers
    function handleControlAction(cKey) {
      const text = i18n[settings.lang];
      switch (cKey) {
        case "contrast-dark":
          setContrast("dark");
          break;
        case "contrast-light":
          setContrast("light");
          break;
        case "contrast-mono":
          setContrast("mono");
          break;
        case "readable-font":
          toggleSetting("readableFont", text.statusFontReadable);
          break;
        case "highlight-links":
          toggleSetting("highlightLinks", text.statusLinksHighlight);
          break;
        case "highlight-titles":
          toggleSetting("highlightTitles", text.statusTitlesHighlight);
          break;
        case "stop-animations":
          toggleSetting("stopAnimations", text.statusAnimationsStop);
          break;
        case "ruler":
          toggleSetting("ruler", text.statusRuler);
          break;
        case "mask":
          toggleSetting("mask", text.statusMask);
          break;
        case "keyboard-focus":
          toggleSetting("keyboardFocus", text.statusKeyboardFocus);
          break;
      }
    }

    // Slider-like button groups handlers
    bindButtonGroup("peach-acc-textsize-group", (val) => setTextSize(parseInt(val)));
    bindButtonGroup("peach-acc-cursor-group", (val) => setCursor(val));
    bindButtonGroup("peach-acc-lineheight-group", (val) => setLineHeight(parseInt(val)));
    bindButtonGroup("peach-acc-spacing-group", (val) => setSpacing(parseInt(val)));
  }

  // Generic button group helper
  function bindButtonGroup(groupId, callback) {
    const group = document.getElementById(groupId);
    if (!group) return;

    group.querySelectorAll("button").forEach(btn => {
      btn.addEventListener("click", function () {
        const val = this.getAttribute("data-val");
        callback(val);
      });
    });
  }

  // --- Initial Script Bootloader ---

  function init() {
    fab = document.getElementById("peach-acc-fab-trigger");
    if (!fab) {
      return;
    }

    // Load stored config, if any
    loadSettings();
    
    // Inject overlays and announcer
    initDOMHelpers();

    // Map FAB Toggle Click & Keyboard
    fab.addEventListener("click", function () {
      if (modal && modal.classList.contains("is-open")) {
        closeModal();
      } else {
        openModal();
      }
    });

    const skipTrigger = document.getElementById("peach-acc-skip-trigger");
    if (skipTrigger) {
      skipTrigger.addEventListener("click", function (e) {
        e.preventDefault();
        openModal();
      });
    }

    // Apply stored preferences to document immediately on load
    applyAccessibilityOverrides();
  }

  // Boot up when document is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
